import { PayloadAction } from '@reduxjs/toolkit';
import { parseJwt } from '../../helpers/jwt';
import { setOnLocalStorage, StorageKey } from '../../helpers/localstorage';
import {
  AuthUser,
  SignInRequest,
  SignInResponse,
  SignUpRequest,
  SignUpResponse,
} from '../../models/auth.models';
import { RTKQueryAction } from '../core';
import { UserState } from './user.slice';

export const setSignInSignUpDataReducer = (
  state: UserState,
  {
    payload,
  }: RTKQueryAction<
    SignInResponse | SignUpResponse,
    SignInRequest | SignUpRequest
  >
) => {
  // Don't like set in localstorage here, it will be necessary to refactor
  // this part
  setOnLocalStorage(payload.tokens.accessToken, StorageKey.AccessToken);
  setOnLocalStorage(payload.tokens.refreshToken, StorageKey.RefreshToken);

  const jwtData = parseJwt(payload.tokens.accessToken);

  state.isEmailConfirmed = !jwtData.nec;
  state.authToken = payload.tokens.accessToken;
  state.refreshToken = payload.tokens.refreshToken;
  state.authUser = payload.user;
};

export const setAccessTokenReducer = (
  state: UserState,
  action: PayloadAction<string | null>
) => {
  state.authToken = action.payload;
};

export const setRefreshTokenReducer = (
  state: UserState,
  action: PayloadAction<string | null>
) => {
  state.refreshToken = action.payload;
};

export const setIsEmailConfirmedReducer = (
  state: UserState,
  action: PayloadAction<boolean>
) => {
  state.isEmailConfirmed = action.payload;
};

export const setAuthUserReducer = (
  state: UserState,
  action: PayloadAction<AuthUser | null>
) => {
  state.authUser = action.payload;
};
